import styled from 'styled-components';

const Form = styled.form`
  width: 400px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export default Form;
